import { UsersService } from './shared/services/users/users.service';
import { ToolbarService } from './layout/components/toolbar/toolbar.service';
import {
  Component,
  Inject,
  OnInit,
  ViewEncapsulation,
  ViewContainerRef,
  ChangeDetectionStrategy,
  Renderer2,
  viewChild,
  ElementRef,
  inject,
  NgZone,
  effect,
  LOCALE_ID
} from '@angular/core';
import { DOCUMENT, Location } from '@angular/common';
import { Platform } from '@angular/cdk/platform';
import { RouterOutlet } from '@angular/router';
import { IconsLoader } from '@shared/services/icons/icons-loader.service';
import { navigation } from './navigation/navigation';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { routeTransitionAnimations } from './app-router-animations';
import { FuseMatchMediaService } from '@fuse/services/match-media.service';
import { NotificationService } from './shared/services/notification/notification.service';
import { NgScrollbar, NgScrollbarModule } from 'ngx-scrollbar';
import { LeftNavbarComponent } from "./layout/components/left-navbar/left-navbar.component";
import { ToolbarComponent } from "./layout/components/toolbar/toolbar.component";
import { ScrollTopComponent } from "./shared/components/scroll-top/scroll-top.component";
import { RightNavbarComponent } from "./layout/components/right-navbar/right-navbar.component";
import { ScrollbarRefDirective } from './shared/scroll/scrollbar-ref.directive';
import { FromServerService } from './shared/services/from-server/from-server.service';
import { RenderIfDirective } from './shared/directives/render-if.directive';
import { LazyLoadService } from './lazy-load/lazy-load.service';

@UntilDestroy()
@Component({
    selector: 'app',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [routeTransitionAnimations],
    standalone: true,
    imports: [
        LeftNavbarComponent,
        NgScrollbarModule,
        ToolbarComponent,
        RouterOutlet,
        ScrollTopComponent,
        RightNavbarComponent,
        ScrollbarRefDirective,
        RenderIfDirective
    ]
})
export class AppComponent implements OnInit {

  navigation: any;
  sbVisibilityLocked: boolean;
  routerAnimation: any = 'ready';
  zone = inject(NgZone);

  mainScrollBar = viewChild.required(NgScrollbar);
  lazyLoadService = inject(LazyLoadService);
  locale = inject(LOCALE_ID);

  constructor(
    @Inject(DOCUMENT) private document: any,
    public toolbarService: ToolbarService,
    private fuseMediaMatchService: FuseMatchMediaService,
    private platform: Platform,
    private _iconsLoader: IconsLoader,
    private usersService: UsersService,
    private location: Location,
    private renderer: Renderer2,
    private vc: ViewContainerRef,
    private notificationService: NotificationService,
    private el: ElementRef,
    private fromServerService: FromServerService,

  ) {

    if (this.platform.isBrowser) {
      this.notificationService.setViewContainerRef(this.vc);
    /*       
      non funziona correttamente, passato come parametro nel redirect sulla home e gestisco lì,

      this._route.queryParams.subscribe((params: Params) => {
        if (params['token']) {
          this.usersService.updateToken(params['token']);
        }
      }); */

      // DA ATTIVARE PRIMA DELLA PUBBLICAZIONE, AGGIORNANDO GOOGLE TAG MANAGER (Rimosso caricamento script cookie bot da CMP template)

      effect(()=> {
        if(this.usersService.userAction()) {
          this.lazyLoadService.loadScript(`https://consent.cookiebot.eu/uc.js?cbid=5557603d-73c4-4dae-8391-e08a5d64b266&implementation=gtm&consentmode-dataredaction=dynamic&culture=${this.locale}`, true);
        }
      });
    }
    this._iconsLoader.load('core');

    // Get default navigation
    this.navigation = navigation;

    // Add is-mobile class to the body if the platform is mobile
    if (this.platform.ANDROID || this.platform.IOS) {
      this.document.body.classList.add('is-mobile');

      this.fuseMediaMatchService.onMediaChange$
      .pipe(
        untilDestroyed(this)
      ).subscribe(async ({matchingAliases}) => {
        if (matchingAliases.includes('HandsetLandscape')) {
          if (!document.fullscreenElement) {
            this.usersService.confirmAction({
              title: $localize`Warning`,
              message: $localize`Landscape mode is not allowed on this web app!`,
              cancelText: null,
              confirmText: $localize`Ok`
            })
            .subscribe(res => {
              this.lockScreenPortrait(true);
            });
          }
        }
      });

    }
  }

  ngOnInit(): void {
    if (this.platform.isBrowser) {
      this.renderer.removeClass(this.el.nativeElement, 'ssr');
    }
  }

  routerAnimDone(e): void {
    this.routerAnimation = 'ready';
  }

  setAnimation(outlet: RouterOutlet): void {
    if (this.platform.isBrowser && !this.fromServerService.isFromServer) {
      const _state = this.location.getState();

      if (_state && _state[`stand`]) {
        const dir = _state[`stand`];
        const p = dir === 'next' ? 100 : -100;
        this.routerAnimation = {value: 'slideStand', params: {enter: p, leave: -p }};
      }
    } 
  }

  private lockScreenPortrait(lock: boolean): Promise<any> {
    let goFullScreen = 'requestFullscreen';
    let exitFullScreen = 'exitFullscreen';
    let orientKey = 'orientation';
    if ('mozOrientation' in screen) {
      orientKey = 'mozOrientation';
    } else if ('msOrientation' in screen) {
      orientKey = 'msOrientation';
    }
    const docEl = document.documentElement;
    if ('mozRequestFullScreen' in docEl) {
      goFullScreen = 'mozRequestFullScreen';
      exitFullScreen = 'mozCancelFullScreen';
    } else if ('webkitRequestFullscreen' in docEl) {
      goFullScreen = 'webkitRequestFullscreen';
      exitFullScreen = 'webkitExitFullscreen';
    } else if ('msRequestFullscreen' in docEl) {
      goFullScreen = 'msRequestFullscreen';
      exitFullScreen = 'msExitFullscreen';
    }
    if (docEl[goFullScreen]) {
      if (lock) {
        docEl[goFullScreen]({navigationUI: 'show'});
      } else {
        docEl[exitFullScreen]();
      }

      const promise = lock ? screen[orientKey].lock('portrait') : screen[orientKey].unlock();
      promise.then(res => {
        return res;
      })
      .catch(err => {
        return err;
      });

    } else {
      return Promise.resolve(false);
    }
  }
}
